import { createAuthHeaders } from '../utils/Authentication'
import { callBackend } from '../utils/BackendCalls'
import { microservices } from '../utils/Microservices'

const getUser = () => {
  return callBackend(microservices.USER, 'user', {
    headers: createAuthHeaders()
  })
}


const updateDeedBookmark = (deed_id, bookmarked) => {
  return callBackend(microservices.USER, `deed/bookmark`, {
    headers: createAuthHeaders(),
    body: {
      id: deed_id,
      bookmarked: bookmarked,
    },
    method: "PUT"
  })
    .catch(() => {
      return { error: true }
    })
}

const updateClauseBookmark = (clause_id, bookmarked) => {
  return callBackend(microservices.USER, `clause/bookmark`, {
    headers: createAuthHeaders(),
    body: {
      id: clause_id,
      bookmarked: bookmarked,
    },
    method: "PUT"
  })
    .catch(() => {
      return { error: true }
    })
}

export { getUser, updateDeedBookmark, updateClauseBookmark }
